import { queryOptions, useQuery } from '@tanstack/react-query';
import { FlowService } from '../service/FlowService';

const FLOW_STALE_TIME_MS = 5 * 60 * 1000;

const flowQueries = {
  detail: (flowId: string) =>
    queryOptions({
      queryKey: ['flow', flowId] as const,
      queryFn: async ({ signal }) => {
        const response = await FlowService.getFlow(flowId, signal);
        return response.data;
      },
      staleTime: FLOW_STALE_TIME_MS,
      refetchOnWindowFocus: false,
    }),
};

const useFlowQuery = (flowId: string | null | undefined) =>
  useQuery({
    ...flowQueries.detail(flowId ?? ''),
    enabled: Boolean(flowId),
  });

export { flowQueries, useFlowQuery };
